import { render } from "./PropAliases.vue?vue&type=template&id=13459746"
import script from "./PropAliases.vue?vue&type=script&lang=js"
export * from "./PropAliases.vue?vue&type=script&lang=js"
script.render = render

export default script